<div class="overlay {currentSeat}" class:map={'map' in state}>
  <div class="text">
    {state.questions[vars.scope]}
  </div>
  <div class="options">
    {#each state.options as btn,i}
      {#if 'map' in state}
        <button data-seat={seats[i]} class={btnClasses[state.options.length][i]} on:mouseover={mover} on:mouseout={mout} on:click={()=>{ btn.fn() }}>{btn.names[vars.scope]}</button>
      {:else}
        <button class={btnClasses[state.options.length][i]} on:click={()=>{ btn.fn() }}>{btn.names[vars.scope]}</button>
      {/if}
    {/each}
  </div>
</div>

<style type="text/scss">
@import '../sass/breakpoints';

// Preloader
:global(body){ 
  &::after{
   position:absolute; width:0; height:0; overflow:hidden; z-index:-1;
   content:url('/res/plans/floor-a.jpg') url('/res/plans/floor-b.jpg') url('/res/plans/floor-c.jpg');
  }
}
// 
.overlay{
  position:absolute;
  top:0px; left:0px;
  width:100%; height:100%;
  background-color:#000000CD;
  display:flex;
  flex-direction:column;
  justify-content:space-around;
  align-items:center;    
  &.map{
    background-image:url('/res/plans/floor.jpg');
    background-size:contain;
    background-position:50% 50%;
    justify-content:space-between;
    .text{ color:black; margin-top:20px; }
    .options button{
      color:black;
      margin-bottom:20px;
    }    
  }
  &.a{ background-image:url('/res/plans/floor-a.jpg');}
  &.b{ background-image:url('/res/plans/floor-b.jpg');}
  &.c{ background-image:url('/res/plans/floor-c.jpg');}
  .text{
    font-size:34px;
    letter-spacing:-0.41px;
    font-weight:700;
    margin:0px 100px;
    text-align:center;
    margin-top:70px;
  }
  .options{
    display:flex;
    flex-direction:row;
    justify-content:center;   
    width:100%;
    button{
      width:30%;      
      border-radius:0;
      margin:10px;
      margin-bottom:100px;
      height:80px;
      background-color:transparent;      
      background-size:contain;
      background-repeat:no-repeat;
      background-position:50% 50%;      
      &.left{ 
        background-image:url('/res/arrow-left.svg'); 
        &:hover{
          background-image:url('/res/arrow-left-active.svg'); 
        }
      }
      &.right{ 
        background-image:url('/res/arrow-right.svg'); 
        &:hover{
          background-image:url('/res/arrow-right-active.svg'); 
        }
      }
      &.middle{ 
        background-image:url('/res/arrow-middle.svg'); 
        &:hover{
          background-image:url('/res/arrow-middle-active.svg'); 
        }
      }
    }
  }
}
@media #{$mobile-landscape}{	
  .overlay{
    align-items:center;
    .text{
      font-size:15px;
      margin:10px 50px;      
    }
    .options{      
      button{
        margin-bottom:auto;
        padding:0px;
        width:50%;
      }
    }
  }
}
</style>

<script>
const btnClasses = {
  1:['middle'],
  2:['left','right'],
  3:['left','middle','right'],
}
const seats = ['a','b','c']
let currentSeat = ''

export let state
export let vars

const mover = self => {
  let seat = self.target.getAttribute('data-seat')
  currentSeat = seat
}
const mout = () => {
  currentSeat = ''
}
</script>